import helper from 'helpers/steinerHelper';
    
export const actionTypes = helper.createActionTypes('questionari');
export const actions = helper.createActions('questionari', actionTypes);